import {IconButton} from '@dropbox/dig-components/buttons';
import {LayerContext} from '@dropbox/dig-components/layer';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronLeftLine, ChevronRightLine} from '@dropbox/dig-icons/assets';
import cx from 'classnames';
import {t} from 'i18next';

// DIG adds its elevated overlay offset to this value; keep sidebar-toggle
// tooltips above nearby fixed/absolute sidebar chrome.
const SIDEBAR_COLLAPSE_TOOLTIP_LAYER_Z_INDEX = 20;

type SidebarCollapseToggleButtonProps = {
  collapsed: boolean;
  onToggle: () => void;
  className: string;
  collapsedClassName: string;
  iconButtonClassName: string;
};

export const SidebarCollapseToggleButton = ({
  collapsed,
  onToggle,
  className,
  collapsedClassName,
  iconButtonClassName,
}: SidebarCollapseToggleButtonProps) => {
  const tooltipTitle = t(collapsed ? 'expand_sidebar' : 'collapse_sidebar');

  return (
    <div
      className={cx(className, {
        [collapsedClassName]: collapsed,
      })}
      data-sidebar-collapse-toggle
      data-sidebar-collapse-toggle-state={collapsed ? 'collapsed' : 'expanded'}
    >
      <LayerContext.Provider value={{zIndex: SIDEBAR_COLLAPSE_TOOLTIP_LAYER_Z_INDEX}}>
        <Tooltip
          key={collapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}
          title={tooltipTitle}
          placement="right"
          openDelay={1000}
          shouldCloseOnClick
        >
          <IconButton
            aria-label={tooltipTitle}
            className={iconButtonClassName}
            shape="circular"
            size="small"
            variant="outline"
            onClick={onToggle}
          >
            <UIIcon src={collapsed ? ChevronRightLine : ChevronLeftLine} size="medium" />
          </IconButton>
        </Tooltip>
      </LayerContext.Provider>
    </div>
  );
};
